import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ProjectCard from './ProjectCard';
import MainStore from '../../../MainStore';
import AuthStore from '../../Auth/AuthStore';
import { Droppable } from 'react-beautiful-dnd'
import { Draggable } from 'react-beautiful-dnd'
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import 'react-virtualized/styles.css';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';

export default class ProjectColumn extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mouseIsHovering: false,
            isCollapsed: localStorage.getItem('filter_project_isCollapsed_' + this.props.id) === 'true'
        };
        this.handleCollapseClick = this.handleCollapseClick.bind(this);

        const cache = new CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: 127
        });
        this.cache = cache;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ mouseIsHovering: false });
    }

    sort(a, b) {
        var res = b.priorityOrder - a.priorityOrder;
        return res !== 0 ? res : a.position - b.position;
    }

    handleCollapseClick() {
        var newValue = !this.state.isCollapsed;
        this.setState({ isCollapsed: newValue });
        localStorage.setItem('filter_project_isCollapsed_' + this.props.id, newValue);
    }

    generateKanbanCards() {
        if (this.state.isCollapsed) return [];
        return this.props.projects.slice(0).sort(this.sort).map((project, index) => {
            return (
                <Draggable draggableId={project.id} index={index} key={project.id}>
                    {(provided, snapshot) => (
                        <ProjectCard
                            project={project}
                            key={project.id}
                            innerRef={provided.innerRef}
                            provided={provided}
                            isDragging={snapshot.isDragging}
                            snapshot={snapshot}
                            onTimeChange={this.props.onTimeChange}
                            onDragEnd={this.props.onDragEnd}
                            onWorkUpdate={this.props.onWorkUpdate}
                            onCardOpen={this.props.onCardOpen}
                            onDragPositionChange={this.props.onDragPositionChange}
                            onCtrlCardClick={this.props.onCtrlCardClick}
                        />)
                    }
                </Draggable>
            );
        });
    }

    generateVirtualKanbanCards = (projects) => ({ index, parent, key, style }) => {
        if (projects.length == 0) return;
        const project = projects[index];
        return (
            <Draggable draggableId={project.id} index={index} key={project.id}>
                {(provided, snapshot) => (
                    <CellMeasurer
                        key={key}
                        cache={this.cache}
                        parent={parent}
                        columnIndex={0}
                        rowIndex={index}
                    >
                        <ProjectCard
                            project={project}
                            key={project.id}
                            innerRef={provided.innerRef}
                            provided={provided}
                            isDragging={snapshot.isDragging}
                            snapshot={snapshot}
                            onTimeChange={this.props.onTimeChange}
                            onDragEnd={this.props.onDragEnd}
                            onWorkUpdate={this.props.onWorkUpdate}
                            onCardOpen={this.props.onCardOpen}
                            onDragPositionChange={this.props.onDragPositionChange}
                            onCtrlCardClick={this.props.onCtrlCardClick}
                            style={{ ...style }}
                        />
                    </CellMeasurer>)
                }
            </Draggable>
        );
    }

    render() {
        return (
            <div className={"droppable-column " + ((this.props.isCollapseColumn && this.state.isCollapsed) ? "collapsed-column" : "")}>
                <Droppable droppableId={this.props.id} type="TASK" mode="virtual"
                    renderClone={(
                        provided,
                        snapshot,
                        rubric,
                    ) => (
                            <ProjectCard
                                project={this.props.projects.sort(this.sort)[rubric.source.index]}
                                key={this.props.projects.sort(this.sort)[rubric.source.index].id}
                                innerRef={provided.innerRef}
                                provided={provided}
                                isDragging={snapshot.isDragging}
                                snapshot={snapshot}
                                onTimeChange={this.props.onTimeChange}
                                onDragEnd={this.props.onDragEnd}
                                onWorkUpdate={this.props.onWorkUpdate}
                                onCardOpen={this.props.onCardOpen}
                                onDragPositionChange={this.props.onDragPositionChange}
                                onCtrlCardClick={this.props.onCtrlCardClick}
                            />
                        )
                    }
                >
                        {(droppableProvided) => (
                            <div className="kanban-column">
                                <div className="clearfix" style={{ "display": "flex"}}>
                                    <div className={"column-title " + this.props.id}>{this.props.name}</div>
                                    <div className="column-counter">{this.props.projects && this.props.projects.length}</div>
                                    {this.props.isCollapseColumn && <IconButton
                                        onClick={this.handleCollapseClick}
                                        style={{ "padding": "2px" }}
                                        size="large">
                                        {!this.state.isCollapsed && <ChevronLeftIcon />}
                                        {this.state.isCollapsed && <ChevronRightIcon />}
                                    </IconButton>}
                                </div>
                                <AutoSizer disableWidth>
                                    {({ height }) => (
                                        <List

                                            height={height}
                                            rowCount={this.props.projects.length}
                                            width={320}
                                            style={{ "width": "calc(100wh/5)" }}
                                        rowHeight={127}
                                            ref={ref => {
                                                // react-virtualized has no way to get the list's ref that I can so
                                                // So we use the `ReactDOM.findDOMNode(ref)` escape hatch to get the ref
                                                if (ref) {
                                                    // eslint-disable-next-line react/no-find-dom-node
                                                    const whatHasMyLifeComeTo = ReactDOM.findDOMNode(ref);
                                                    if (whatHasMyLifeComeTo instanceof HTMLElement) {
                                                        droppableProvided.innerRef(whatHasMyLifeComeTo);
                                                    }
                                                }
                                            }}
                                            rowRenderer={this.generateVirtualKanbanCards(this.props.isCollapseColumn && this.state.isCollapsed ? [] : this.props.projects.sort(this.sort))}
                                        />)}
                                </AutoSizer>
                            </div>
                    )}
                </Droppable>
            </div>
        );
    }
}